import { Card, View, Image } from "@/components/ui";
import { Link } from "@/components/shared/link";
import { links } from "@/constants";
import HomeCleaningToolsIcon from "@/assets/images/3d-icons/home-cleaning-tools.png";
import { Typography } from "../typography";

export const HomeCleaningToolsCard = () => {
  return (
    <Card
      variant="info"
      className="m-4 mb-0 items-center gap-0 bg-white"
      direction="row"
    >
      <View className="flex max-w-[82px] flex-1">
        <Image src={HomeCleaningToolsIcon} width={82} height={82} />
      </View>
      <View className="flex flex-1 flex-col items-start gap-1 p-3 md:gap-2">
        <Typography variant="label-sm" color="brand-primary">
          Your Tools for a Safer Clean
        </Typography>
        <Typography variant="caption-md">
          Shared cloths and mops can transfer germs between homes. For hygiene,
          we don’t bring equipment and will use your home’s cleaning tools.
        </Typography>
        <Link href={links.equipmentList} target={links.equipmentList}>
          <Typography
            variant="caption-md"
            color="brand-primary"
            className="underline"
          >
            See our prep list
          </Typography>
        </Link>
      </View>
    </Card>
  );
};
